import Vue from 'vue'

const $utils = {
    copyToClipboard (str, notificationText) {
        const el = document.createElement('textarea')
        el.value = str
        document.body.appendChild(el)
        el.select()
        document.execCommand('copy')
        document.body.removeChild(el)
        if (notificationText !== null && notificationText !== undefined) {
            window.vueapp.$AppService.toastSuccess(notificationText)
        }
    },
    isMobile () {
        return window.vueapp.$vuetify.breakpoint.name === 'xs'
    },
    colorSamples: [
        '#ffb100',
        '#42be80',
        '#379cfd',
        '#40bf87',
        '#b7bf40',
        '#4840bf',
        '#bf6840',
        '#4097bf',
        '#58bf40',
        '#a740bf',
        '#40bf4c'
    ],
}

Vue.prototype.$utils = $utils

export default $utils
